import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { request } from "../api/http";

var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ContactModal({ show, onHide, product, slug }) {
    var [email, setEmail] = useState("");
    var [message, setMessage] = useState("");
    var [errors, setErrors] = useState({});
    var [sending, setSending] = useState(false);
    var [info, setInfo] = useState(null);

    // clear form when modal closes
    useEffect(function () {
        if (!show) {
            setEmail("");
            setMessage("");
            setErrors({});
            setInfo(null);
            setSending(false);
        }
    }, [show]);

    function validate() {
        var next = {};
        var emailTrim = (email || "").trim();
        var msgTrim = (message || "").trim();

        if (!emailTrim) { next.email = "Zadajte email."; }
        else if (!EMAIL_RE.test(emailTrim)) { next.email = "Neplatný email."; }

        if (!msgTrim) { next.message = "Napíšte správu."; }

        setErrors(next);
        return Object.keys(next).length === 0;
    }

    function handleSubmit(e) {
        e.preventDefault();
        setInfo(null);
        if (!validate()) { return; }

        var payload = {
            email: email.trim(),
            message: message.trim(),
            productId: product?.id || null,
            productName: product?.name || null,
            productSlug: slug || product?.slug || null
        };

        setSending(true);
        request("/api/contact", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        })
            .then(function () {
                setInfo({ type: "success", text: "Správa bola odoslaná. Ozveme sa čoskoro." });
                setEmail("");
                setMessage("");
            })
            .catch(function (err) {
                var msg = err?.message || "Odoslanie zlyhalo.";
                setInfo({ type: "danger", text: msg });
            })
            .finally(function () { setSending(false); });
    }

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Napíšte nám</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="contactEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="vas@email.com"
                            value={email}
                            onChange={function (e) { setEmail(e.target.value); }}
                            isInvalid={!!errors.email}
                            disabled={sending}
                        />
                        {errors.email && <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>}
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="contactMessage">
                        <Form.Label>Správa</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={8}
                            placeholder="Sem napíšte svoju správu…"
                            value={message}
                            onChange={function (e) { setMessage(e.target.value); }}
                            isInvalid={!!errors.message}
                            disabled={sending}
                        />
                        {errors.message && <Form.Control.Feedback type="invalid">{errors.message}</Form.Control.Feedback>}
                    </Form.Group>

                    {info && (
                        <Alert variant={info.type} className="mb-3">
                            {info.text}
                        </Alert>
                    )}

                    <div className="d-flex gap-2">
                        <Button variant="brown" type="submit" disabled={sending}>
                            {sending ? "Odosielam..." : "Odoslať"}
                        </Button>
                        <Button variant="outline-secondary rounded-pill" onClick={onHide} disabled={sending}>Zavrieť</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ContactModal;
